import React, { useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import PagePanel from 'src/components/PagePanel';
import PageHeader from 'src/components/PageHeader';
import {
  ROUTE_MANAGEMENT_ADMINS,
  // ROUTE_MANAGEMENT_PERMISSIONS,
  ROUTE_MANAGEMENT_ROLES,
} from 'src/utils/routes';

import AdminUsers from 'src/pages/Management/AdminUsers';
// import Permissions from 'src/pages/Management/Permissions';
import Roles from 'src/pages/Management/Roles';

import { ManagementTab, ManagementTabs } from './styled';

const TABS = [
  { label: 'All Users', path: ROUTE_MANAGEMENT_ADMINS },
  // { label: 'Permissions', path: ROUTE_MANAGEMENT_PERMISSIONS },
  { label: 'Roles', path: ROUTE_MANAGEMENT_ROLES },
];

const ManagementLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState<number | null>(null);
  const isRoles = location.pathname.startsWith(ROUTE_MANAGEMENT_ROLES);
  const title =
    totalCount == null
      ? isRoles
        ? 'Roles'
        : 'All Users'
      : isRoles
        ? `Roles (${totalCount})`
        : `All Users (${totalCount})`;

  return (
    <PagePanel>
      <PageHeader title={title} hideSearch />
      <ManagementTabs>
        {TABS.map((tab) => (
          <ManagementTab
            key={tab.path}
            type="button"
            $active={location.pathname === tab.path}
            onClick={() => {
              setTotalCount(null);
              navigate(tab.path);
            }}
          >
            {tab.label}
          </ManagementTab>
        ))}
      </ManagementTabs>
      <Routes>
        <Route index element={<Navigate to={ROUTE_MANAGEMENT_ADMINS} replace />} />
        <Route path="admins" element={<AdminUsers onTotalChange={setTotalCount} />} />
        <Route path="roles" element={<Roles onTotalChange={setTotalCount} />} />
        {/* <Route path="permissions" element={<Permissions />} /> */}
      </Routes>
    </PagePanel>
  );
};

export default ManagementLayout;
